<div  class="others-form feedback-form h-100">
    <div class="form-section">
        <div class="section-header">
            <!-- <div class="section-title">Other Feedback</div> -->
            <div class="extra-data"><div>Please use this form only to provide feedback about the <b> application itself.</b></div></div>
            <div class="extra-data"><div>Feedback related to models or market analysis should be submited using the other forms.</div></div>
        </div>
        
        <div class="control-container free-text">
            <label for="other_feedback">Share your feedback below:</label>
            <textarea 
            pInputTextarea 
            [(ngModel)]="freeText"
            [ngClass]="{ 'invalid-input': !isValid() }"
            [disabled]="isFieldDisabled()"
            (input)=" validateFreeText($event)"  
            (blur)="onFreeTextEntered()"     
            rows="10" cols="30" 
            
            placeholder="Enter your comments here..."></textarea>
            <small [ngClass]="{ 'visible': !isValid() }">Your feedback must contain at least two words</small>

        </div>

    </div>

</div>
